import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "CatalogueProductDetail" })
export default class CatalogueProductDetail extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = true;
    public tabSelected: string = "Informations";
    public activeTabs: any = {};
    public deliveryReturn: any = null;

    @Prop() readonly isStoreProduct: boolean;
    @Prop() readonly culture: string;
    @Prop() readonly familyCode: any;
    @Prop() readonly orderCode: any;
    @Prop() readonly productViewPdfUrl: string;
    @Prop() readonly productPdfUrl: string;
    @Prop() readonly itemCode: string;
    @Prop() readonly itemRevision: string;
    @Prop() readonly isAuthenticated: boolean;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        this.isLoading = true;
        const response = (await Axios.post(this.routes.Catalogue_GetProductDetailData, { itemCode: this.itemCode, itemRevision: this.itemRevision })).data;
        this.activeTabs = response;

        let tab = <string>this.$route.query.tab != null ? <string>this.$route.query.tab : null;

        if ((this.activeTabs.isConfiguration && tab === "Configurations") || (this.activeTabs.isAccessories && tab === "Accessories") || (this.activeTabs.isDocumentation && tab === "Documentation") || (this.isStoreProduct && tab === "DeliveryAndReturn")) {
            this.setTab(tab);
        } else {
            this.setTab("Informations");
        }

        this.isLoading = false;
    }

    public async setTab(value: string) {
        this.tabSelected = value;

        if (value === "DeliveryAndReturn") {
            await this.getData();
        }
    }

    public async getData() {
        if (!this.deliveryReturn) {
            const response = (await Axios.post(this.routes.Catalogue_GetProductDetailDeliveryAndReturnData)).data;
            this.deliveryReturn = Object.freeze(response);
        }
    }
};